var convertFileListToFileArray = function convertFileListToFileArray(fileList) {
  var files = [];
  if (!fileList) return files;
  for (var i = 0; i < fileList.length; i++) {
    var file = fileList.item(i);
    if (file) files.push(file);
  }
  return files;
};

export { convertFileListToFileArray };
